import { OnClickAsync } from '@csp/csp-web-ui';
import { StorageService } from '@csp/web-storage';

import { isProdLikeEnv } from '../../../../../../system/service/CspConfigService';
import { Command } from '../../../../model/Command';
import { CommandCategory } from '../../../../model/CommandCategoryType';

export const isDarkModeOn = (): boolean =>
  !isProdLikeEnv() && StorageService.localStorage.getItem('darkMode') === 'true';

export const useToggleDarkModeCommand = (): Command => {
  const toggleTheme: OnClickAsync = async () => {
    try {
      const isCoolMode = isDarkModeOn();
      StorageService.localStorage.setItem('darkMode', !isCoolMode);
    } catch (e) {
      console.error(e);
    }
    window.location.reload();
  };

  return {
    id: 'dark-mode',
    title: 'Toggle Dark Mode',
    category: CommandCategory.MISC,
    chipLabel: isDarkModeOn() ? 'On' : 'Off',
    chipStatusColor: isDarkModeOn() ? 'success' : 'inactive',
    chipTooltipLabel: 'Click to toggle dark mode',
    onSelect: toggleTheme,
  };
};
